(function(app) {
    app.component("vizCard", {
        templateUrl: "/App/States/VizUIComponents/Card/viz.card.html",
        bindings: {
            cardTitle: "<",
            isExpanded: "=",
            isDisabled: "="
        },
        controller: _vizCardCtrl,
        transclude: true
    });

    function _vizCardCtrl() {
        let $ctrl = this;

        $ctrl.click = () => {
            if ($ctrl.cardTitle.includes('No Data Available')) {
                return;
            }
            $ctrl.isExpanded = !$ctrl.isExpanded;
        };
    }
})(window.app);
